export enum SalesApprovalAction {
  APPROVE,
  REJECT,
  APPROVE_FILL,
  CANCEL_FILL,
  CLEAR_FILL,
}

export namespace SalesApprovalAction {
  let elements = [
    SalesApprovalAction.APPROVE,
    SalesApprovalAction.REJECT,
    SalesApprovalAction.APPROVE_FILL,
    SalesApprovalAction.CANCEL_FILL,
    SalesApprovalAction.CLEAR_FILL,
  ];
  let alias = "com.bcdfx.api.servicerequest.sales.SalesApprovalAction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
